/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/charger_medium'
export default icon
